export default "__VITE_ASSET__D2Jni$KQ__"